import adokFull from './logos/adok-full.png'
import adokMini from './logos/adok-mini.png'
import adokSvg from './logos/adok-svg.svg'
import adokWhite from './logos/adok-white.png'

export interface AppLogos {
  wideLogo: string
  miniLogo: string
  svgLogo: string
  darkLogo: string
}

export const adokLogos: AppLogos = {
  wideLogo: adokFull,
  miniLogo: adokMini,
  svgLogo: adokSvg,
  darkLogo: adokWhite
}
